"use client";

import DataImportIntroModal from "@/components/tour/DataImportIntroModal";
import OnboardingImportModal from "@/components/tour/OnboardingImportModal";
import { TourWelcomeModal } from "@/components/tour/TourWelcomeModal";
import { ImportProvider } from "@/context/importContext";
import { useTour } from "@/context/TourContext";
import { isTourBlockedRoute } from "@/utils/tour-utils";
import { usePathname } from "next/navigation";
import React, { useEffect, useState } from "react";

interface TourWrapperProps {
  children: React.ReactNode;
}

export const TourWrapper: React.FC<TourWrapperProps> = ({ children }) => {
  const { tourState, closeWelcomeModal, startTourFromWelcome } = useTour();
  const [isMobile, setIsMobile] = useState(false);
  const pathname = usePathname();

  // Detect mobile devices
  useEffect(() => {
    const checkMobile = () => {
      const isMobileDevice =
        window.innerWidth < 768 ||
        /Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        );
      setIsMobile(isMobileDevice);
    };

    checkMobile();
    window.addEventListener("resize", checkMobile);

    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  // Check if we're on a links route (shared links)
  const currentPath = pathname || "";
  const isLinksRoute =
    currentPath.startsWith("/candidates/") ||
    currentPath.startsWith("/customers/") ||
    currentPath.startsWith("/services/") ||
    currentPath.startsWith("/view/budget/") ||
    currentPath.startsWith("/info/") ||
    currentPath.startsWith("/invalid");
  const isBlockedRoute = isTourBlockedRoute(currentPath);
  const shouldRenderTourUI = !isMobile && !isLinksRoute && !isBlockedRoute;

  return (
    <>
      {children}
      {shouldRenderTourUI && (
        <>
          <TourWelcomeModal
            isOpen={tourState.showWelcomeModal}
            onClose={closeWelcomeModal}
            onStartTour={startTourFromWelcome}
          />
          <DataImportIntroModal />
          <ImportProvider>
            <OnboardingImportModal />
          </ImportProvider>
        </>
      )}
    </>
  );
};
